module.exports = __webpack_public_path__ + "static/image/font/pc/bmhannaair-1@3x.jpg?05b14ff2";